import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {FormControl, InputGroup} from "react-bootstrap";

class TextInput  extends React.Component{
    constructor(props) {
        super(props);
        this.state={};
    }

    render() {
        return (
            <InputGroup className="mb-3">
                <InputGroup.Prepend>
                    <InputGroup.Text id="basic-addon1">
                        <FontAwesomeIcon icon="pencil-alt" />
                    </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    as="textarea"
                    rows="8"
                    id={this.props.id}
                    placeholder={this.props.placeholder}
                    aria-label={this.props.label}
                    aria-describedby="basic-addon1"
                    title={this.props.title}
                    onChange={this.props.onChange}
                    onKeyUp={this.handleKeyUp}
                />
            </InputGroup>
        );
    }
}

export default TextInput;
